import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function LightningBolt({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <LightningBolt.Outline {...props} />
  ) : (
    <LightningBolt.Solid {...props} />
  );
}

LightningBolt.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <circle
          cx="12"
          cy="12"
          r="11"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          className="icon-outline"
        />
        <path
          d="M9.92209 7.54713C10.0926 7.21146 10.4372 7 10.8137 7H14.6287C14.9597 7 15.1475 7.37912 14.9469 7.64242L12.6035 10.7182C12.453 10.9157 12.5938 11.2 12.8421 11.2H15.9288C16.1882 11.2 16.3253 11.5068 16.1524 11.7001L9.89057 18.6957C9.82079 18.7736 9.6933 18.7056 9.71917 18.6043L10.9772 13.6742C11.0257 13.4845 10.8823 13.3 10.6866 13.3H7.81477C7.4417 13.3 7.20003 12.9062 7.36898 12.5736L9.92209 7.54713Z"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

LightningBolt.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
        <g>
          <path
            d="M9.92209 7.54713C10.0926 7.21146 10.4372 7 10.8137 7H14.6287C14.9597 7 15.1475 7.37912 14.9469 7.64242L12.6035 10.7182C12.453 10.9157 12.5938 11.2 12.8421 11.2H15.9288C16.1882 11.2 16.3253 11.5068 16.1524 11.7001L9.89057 18.6957C9.82079 18.7736 9.6933 18.7056 9.71917 18.6043L10.9772 13.6742C11.0257 13.4845 10.8823 13.3 10.6866 13.3H7.81477C7.4417 13.3 7.20003 12.9062 7.36898 12.5736L9.92209 7.54713Z"
            fill="currentColor"
          />
        </g>
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
